// extracted by mini-css-extract-plugin
export var dotWrapper = "component-module--dotWrapper--7f38c";
export var main = "component-module--main--f0441";